import { Pipe, PipeTransform } from '@angular/core';
import { PVIPlanDetail } from '@gtd/api-services/service-inventory';

@Pipe({
  name: 'groupByAgeRange'
})
export class GroupByAgeRangePipe implements PipeTransform {
  transform(pricesDetails: PVIPlanDetail[]): PVIPlanDetail[] {
    if (!pricesDetails || !pricesDetails.length) return [];

    const ageGroupMap = new Map<string, PVIPlanDetail>();

    pricesDetails.forEach(detail => {
      if (detail.age === undefined || isNaN(detail.age)) {
        return;
      }

      const ageGroup = this.categorizeAge(detail.age);
      if (!ageGroupMap.has(ageGroup)) {
        ageGroupMap.set(ageGroup, {
          ...detail,
          description: ageGroup
        });
      }
    });
    const order = ['0-56', '56-66', '66-85', 'Không xác định'];
    return Array.from(ageGroupMap.values()).sort((a, b) => {
      return order.indexOf(a.description) - order.indexOf(b.description);
    });
  }

  private categorizeAge(age: number | undefined): string {
    if (age === undefined || isNaN(age)) {
      return 'Không xác định';
    }
    if (age >= 0 && age < 56) {
      return '0-56';
    } else if (age >= 56 && age < 66) {
      return '56-66';
    } else if (age >= 66 && age < 85) {
      return '66-85';
    } else {
      return 'Không xác định';
    }
  }
}
